import React from 'react';
import { motion } from 'framer-motion';
import { LockIcon, ZapIcon, ShieldIcon, CreditCardIcon, FileTextIcon, FlagIcon } from 'lucide-react';
export function FinalCTA() {
  const trustBadges = [{
    icon: <LockIcon className="w-4 h-4" data-id="element-60" />,
    text: 'Pago 100% seguro'
  }, {
    icon: <ZapIcon className="w-4 h-4" data-id="element-61" />,
    text: 'Acceso en 5 minutos'
  }, {
    icon: <ShieldIcon className="w-4 h-4" data-id="element-62" />,
    text: 'Garantía 7 días'
  }, {
    icon: <CreditCardIcon className="w-4 h-4" data-id="element-63" />,
    text: 'Mercado Pago · Tarjeta · Transferencia'
  }, {
    icon: <FileTextIcon className="w-4 h-4" data-id="element-64" />,
    text: '100% PDF'
  }, {
    icon: <FlagIcon className="w-4 h-4" data-id="element-65" />,
    text: 'Hecho en Argentina'
  }];
  return <section className="w-full bg-neutral-950 py-4 md:py-8" data-id="element-66">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-67">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-68">
          <div className="text-center mb-4 md:mb-6 max-w-3xl mx-auto" data-id="element-69">
            <p className="text-lg md:text-2xl text-neutral-300 italic leading-relaxed" data-id="element-70">
              "Las velas comestibles no son una moda pasajera. Son una categoría
              de producto que llegó para quedarse. La pregunta no es si vas a
              aprender esto — la pregunta es si lo vas a aprender antes o
              después que los demás en tu ciudad."
            </p>
          </div>

          <div className="max-w-2xl mx-auto mb-3 md:mb-6" data-id="element-71">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5
          }} className="bg-neutral-900 border-2 border-amber-500 rounded-lg p-5 md:p-6 relative shadow-[0_0_30px_rgba(251,191,36,0.15)]" data-id="element-72">
              <h4 className="text-xl font-bold text-amber-50 mb-1" data-id="element-73">
                🕯️ MEGA PACK VELAS COMESTIBLES GOURMET
              </h4>
              <p className="text-amber-400 font-semibold mb-2 text-sm" data-id="element-74">
                6 Tomos + 3 Bonos · Precio de lanzamiento
              </p>
              <div className="mb-3" data-id="element-75">
                <div className="flex items-baseline gap-2" data-id="element-76">
                  <span className="text-neutral-500 line-through text-lg" data-id="element-77">
                    $33.980
                  </span>
                  <span className="text-amber-400 font-bold text-3xl" data-id="element-78">
                    $16.990
                  </span>
                  <span className="text-neutral-500 text-sm" data-id="element-79">ARS</span>
                </div>
              </div>
              <motion.a href="https://www.recursohub.com/cart/48298368336064:1" target="_blank" rel="noopener noreferrer" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="block w-full bg-gradient-to-r from-amber-400 to-amber-500 hover:from-amber-300 hover:to-amber-400 text-neutral-950 font-bold text-lg px-6 py-3.5 rounded-lg transition-colors shadow-[0_0_30px_rgba(251,191,36,0.25)] text-center" data-id="element-80">
                🛒 SÍ, QUIERO EMPEZAR HOY
              </motion.a>
              <motion.a href="https://wa.me/543516347235?text=Hola!!%20Tuve%20un%20problema%20con%20el%20pago%20por%20Mercado%20Pago%20del%20Mega%20Pack%20Velas%20Comestibles%20Gourmet.%20%C2%BFMe%20pueden%20ayudar%3F" target="_blank" rel="noopener noreferrer" whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} className="mt-3 flex items-center justify-center gap-2 w-full bg-neutral-900 hover:bg-neutral-800 border border-[#25D366]/40 hover:border-[#25D366] text-[#25D366] font-semibold text-sm px-4 py-2.5 rounded-lg transition-colors text-center" data-id="element-81">
                <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current" data-id="element-82">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" data-id="element-83" />
                </svg>
                ¿Problemas con Mercado Pago? Escribinos por WhatsApp
              </motion.a>
            </motion.div>
          </div>

          <div className="flex flex-wrap gap-1.5 md:gap-2 items-center justify-center" data-id="element-84">
            {trustBadges.map((badge, index) => <motion.div key={index} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.05,
            duration: 0.3
          }} className="flex items-center gap-1 md:gap-1.5 bg-neutral-900 border border-amber-900/40 rounded-full px-2 py-1 md:px-3 md:py-1.5" data-id="element-85">
                <span className="text-amber-400 [&>svg]:w-3 [&>svg]:h-3 md:[&>svg]:w-4 md:[&>svg]:h-4" data-id="element-86">
                  {badge.icon}
                </span>
                <span className="text-[10px] md:text-xs text-neutral-300 font-medium leading-tight" data-id="element-87">
                  {badge.text}
                </span>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}